import React from 'react';
import { Modal, Field } from './ui';

// Super Admin quick "New Event" dialog from the top bar — mobile (full-screen) variant.
export default function NewEventModalMobile({ vm }) {
  const { closeEventModal, eventForm, setEventField, clearEventForm, eventFormDirty, eventTypeOptions, userOptions, savingEvent, addEvent } = vm;
  return (
    <Modal
      title="New Event"
      fullScreen
      onClose={closeEventModal}
      isDirty={eventFormDirty}
      onClear={clearEventForm}
      footer={<>
        <button className="btn light" type="button" onClick={closeEventModal}>Cancel</button>
        <button className="btn primary" type="button" disabled={savingEvent} onClick={addEvent}>
          {savingEvent ? 'Creating...' : 'Create'}
        </button>
      </>}
    >
      <div className="form-grid" style={{ gridTemplateColumns: '1fr' }}>
        <div style={{ gridColumn: '1 / -1' }}>
          <Field label="Event Name" value={eventForm.EventName} onChange={(v) => setEventField('EventName', v)} required />
        </div>
        <div style={{ gridColumn: '1 / -1' }}>
          <Field label="Event Type" type="select" value={eventForm.EventTypeId} options={eventTypeOptions} onChange={(v) => setEventField('EventTypeId', v)} required />
        </div>
        <div style={{ gridColumn: '1 / -1' }}>
          <Field label="Event Admin" type="select" value={eventForm.EventAdminMode} options={['Existing User', 'New User']} onChange={(v) => setEventField('EventAdminMode', v || 'Existing User')} required />
        </div>
        {eventForm.EventAdminMode === 'New User' ? (
          <>
            <Field label="New User Name" value={eventForm.EventAdminName} onChange={(v) => setEventField('EventAdminName', v)} required />
            <Field label="New User Mobile" value={eventForm.EventAdminMobileNumber} onChange={(v) => setEventField('EventAdminMobileNumber', v)} required />
            <div style={{ gridColumn: '1 / -1' }}>
              <Field label="New User Password" value={eventForm.EventAdminPassword} onChange={(v) => setEventField('EventAdminPassword', v)} />
            </div>
          </>
        ) : (
          <div style={{ gridColumn: '1 / -1' }}>
            <Field label="Existing User" type="select" value={eventForm.EventAdminUserId} options={userOptions} onChange={(v) => setEventField('EventAdminUserId', v)} required />
          </div>
        )}
      </div>
    </Modal>
  );
}
